
  import { Vue, Component, Prop } from "vue-property-decorator";
  import RouteNames from "@/entities/RouteNames";

  @Component
  export default class ContractorChip extends Vue {
    @Prop({ type: String, required: true }) readonly contractorId!: string;
    @Prop({ type: String, required: true }) readonly contractorName!: string;

    routes = RouteNames;
  }
